import React from "react";
import { Button } from "antd";

type State = { error: Error | null };

export const ErrorFallback = ({ error }: { error: Error }) => {
  return (
    <div
      className="flex h-screen w-screen flex-col items-center justify-center text-red-500"
      role="alert"
    >
      <h2 className="text-lg font-semibold">Ooops, something went wrong</h2>
      <p className="mt-1">{error.toString()}</p>
      <Button
        type="primary"
        onClick={() => window.location.assign(window.location.origin)}
        className="mt-4"
      >
        Refresh
      </Button>
    </div>
  );
};

export class ErrorBoundary extends React.Component<
  {
    children: Exclude<NonNullable<React.ReactNode>, string | number | boolean>;
  },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  resetError: () => void = () => {
    this.setState({ error: null });
  };

  render() {
    return this.state.error ? (
      <ErrorFallback error={this.state.error} />
    ) : (
      this.props.children
    );
  }
}
